import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { Field, reduxForm, InjectedFormProps } from 'redux-form';
import { Helmet } from 'react-helmet';
import { trim } from 'lodash';

// @ts-ignore
import { getIsLoadingForgotPassword } from 'store/services/session/selectors';
// @ts-ignore
import { forgotPassword } from 'store/services/session/actions';
import { SessionRootState } from 'store/services/session/types';
import Layout from 'components/AuthLayout';
import TextFieldReduxWrapper from 'components/TextFieldReduxWrapper';
// @ts-ignore
import MESSAGES from 'constants/messages';
import FORM_NAMES from 'constants/formNames';

import validate from './utils';

import { SH1, SButton } from './styled';

type FormParams = {
  email: string;
};

interface StateProps {
  isLoading: boolean;
}

interface DispatchProps {
  forgotPassword: () => Promise<boolean>;
}

type CustomProps = StateProps & DispatchProps;

type Props = CustomProps & InjectedFormProps<FormParams, CustomProps>;

const ForgotPassword = ({
  isLoading,
  forgotPassword,
  handleSubmit,
  invalid,
}: Props) => (
  <Layout showExtra onSubmit={handleSubmit(forgotPassword)}>
    <Helmet>
      <title>Forgot your password?</title>
    </Helmet>

    <SH1 data-test="title">Forgot your password?</SH1>

    <Field
      component={TextFieldReduxWrapper}
      data-test="email"
      label="Email"
      name="email"
      normalize={trim}
      placeholder={MESSAGES.FORGOT_PASSWORD.EMAIL.PLACEHOLDER}
      type="email"
    />

    <SButton
      block
      color="primary"
      data-test="submit"
      disabled={invalid || isLoading}
      loading={isLoading}
      type="submit"
      variant="contained"
    >
      Request Reset Link
    </SButton>
  </Layout>
);

const mapStateToProps = (
  state: Pick<SessionRootState, 'forgotPassword'>,
): StateProps => ({
  isLoading: getIsLoadingForgotPassword(state),
});

export default compose(
  connect(
    mapStateToProps,
    { forgotPassword },
  ),
  reduxForm({
    form: FORM_NAMES.PASSWORD.FORGOT,
    validate,
    touchOnChange: true,
    initialValues: {
      email: '',
    },
  }),
)(ForgotPassword) as React.FC<
  StateProps & DispatchProps & Partial<InjectedFormProps>
>;
